import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown } from 'react-bootstrap';

import useGlobal from '../../../../../store';
import CustomDropdownToggle from '../../../../../facturotopia/CustomDropdownToggle';

const mapState = (store) => {
  return store.modulo.timbrado_masivo.archivos;
};

const mapActions = (actions) => {
  return { ...actions.modulo.timbrado_masivo.archivos };
};

const FilterButtonType = (props) => {
  const { variant = 'secondary', current, tipo, text, onClick, icon } = props;

  const handleOnClick = () => {
    onClick(tipo ? [tipo] : null);
  };

  return (
    <Dropdown.Item
      variant={variant}
      className={current === tipo && 'active'}
      onClick={handleOnClick}
    >
      {!!icon && <FontAwesomeIcon icon={icon} />}
      {text ? ` ${text}` : ''}
    </Dropdown.Item>
  );
};

const TimbradoMasivoFilterByType = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { tipo } = state.pagination;

  const handleOnClick = (tipo) => {
    actions.paginate({
      page: 1,
      tipo,
    });
  };

  let title = 'Tipo';
  const tipoStr = !tipo || tipo.length > 1 ? '' : tipo[0];

  switch (tipoStr) {
    case 'timbrado-comprobantes':
      title = 'Ingreso + Egreso';
      break;

    case 'timbrado-nomina':
      title = 'Nómina';
      break;
    case 'timbrado-pagos':
      title = 'Pago';
      break;
    default:
      break;
  }

  return (
    <>
      <Dropdown
        title={title}
        id="bg-nested-dropdown"
      >
        <Dropdown.Toggle as={CustomDropdownToggle}>{title}</Dropdown.Toggle>

        <Dropdown.Menu>
          <FilterButtonType
            text="Todos"
            current={tipo}
            tipo=""
            onClick={handleOnClick}
          />

          <FilterButtonType
            text="Ingreso + Egreso"
            current={tipo}
            tipo="timbrado-comprobantes"
            onClick={handleOnClick}
          />

          <FilterButtonType
            text="Nómina"
            current={tipo}
            tipo="timbrado-nomina"
            onClick={handleOnClick}
          />

          <FilterButtonType
            text="Pago"
            current={tipo}
            tipo="timbrado-pagos"
            onClick={handleOnClick}
          />
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default TimbradoMasivoFilterByType;
